import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Navbar.css';

const Navbar = () => {
  const { isLoggedIn, userEmail, logout, isAdmin } = useAuth();
  const navigate = useNavigate();
  const [showDropdown, setShowDropdown] = useState(false); // State to control dropdown visibility
  const [menuOpen, setMenuOpen] = useState(false); // 新增：控制移动端菜单显示

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  // Add a useEffect to log login status changes
  React.useEffect(() => {
    console.log('Navbar login status changed:', { isLoggedIn, userEmail });
  }, [isLoggedIn, userEmail]);

  // Close dropdown when clicking outside (optional but good UX)
  // You might need a more robust click outside handler in a real app
  // Use a ref to handle clicks outside the dropdown
  const dropdownRef = React.useRef(null);

  React.useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on cleanup
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          <img src="/images/tvantlogo.png" alt="Logo" />
          <span>蚂蚁电视</span>
        </Link>
        {/* 汉堡按钮，仅移动端显示 */}
        <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </div>
        {/* 菜单区，移动端收缩为功能区 */}
        <div className={`nav-menu${menuOpen ? ' open' : ''}`}>
          <div 
            className="nav-item" 
            onClick={() => { setMenuOpen(false); navigate(isLoggedIn ? '/purchase' : '/auth'); }}
            style={{ cursor: 'pointer' }}
          >
            套餐選擇
          </div>
          <div 
            className="nav-item" 
            onClick={() => { setMenuOpen(false); navigate(isLoggedIn ? '/orders' : '/auth'); }}
            style={{ cursor: 'pointer' }}
          >
            訂單查詢
          </div>
          <Link to="/customer-service" className="nav-item" onClick={() => setMenuOpen(false)}>客戶服務</Link>
          <Link to="/download" className="nav-item" onClick={() => setMenuOpen(false)}>客戶端下載</Link>
          {isAdmin && (
            <Link to="/admin" className="nav-item" onClick={() => setMenuOpen(false)} style={{ color: '#1976d2', fontWeight: 600 }}>管理后台</Link>
          )}
        </div>

        <div className="nav-right">
          <div className="user-status">
            {isLoggedIn ? (
              <span className="user-email">{userEmail}</span>
            ) : (
              <span className="not-logged-in">未登录</span>
            )}
          </div>

          <div className="user-avatar-container">
            {/* Replace with actual avatar image later */}
            <div className="user-avatar" onClick={toggleDropdown}>
              {/* Placeholder for avatar or initial */}
              {isLoggedIn ? (
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="user-icon logged-in">
                  <path fillRule="evenodd" d="M7.5 6a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zM3.751 20.105a8.25 8.25 0 0116.498 0 .75.75 0 01-.437.695A18.683 18.683 0 0112 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 01-.437-.695z" clipRule="evenodd" />
                </svg>
              ) : (
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="user-icon">
                  <path fillRule="evenodd" d="M7.5 6a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zM3.751 20.105a8.25 8.25 0 0116.498 0 .75.75 0 01-.437.695A18.683 18.683 0 0112 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 01-.437-.695z" clipRule="evenodd" />
                </svg>
              )}
            </div>
            
            {showDropdown && (
              <div className="user-dropdown" ref={dropdownRef}>
                {isLoggedIn ? (
                  <>
                    <div className="dropdown-item user-email-label">邮箱:</div>
                    <div className="dropdown-item user-email-address">{userEmail}</div>
                    <Link to="/change-password" className="dropdown-item" onClick={() => setShowDropdown(false)}>
                      修改密码
                    </Link>
                    <button onClick={handleLogout} className="dropdown-item logout-button-dropdown">
                      退出登录
                    </button>
                  </>
                ) : (
                  <Link to="/auth" className="dropdown-item" onClick={() => setShowDropdown(false)}>未登录</Link>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar; 